import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import {
    type GetLensDiscoverabilityTagCandidatesQuery,
    type GetLensDiscoverabilityTagCandidatesQueryVariables,
    getLensDiscoverabilityTagCandidates,
} from "../api";

export const useLensDiscoverabilityData = (
    lensOrSubmissionId: string,
): {
    lensDiscoverabilityVisualTagCandidates: readonly string[];
    lensDiscoverabilityLocationTagCandidates: readonly string[];
    lensDiscoverabilityTimeTagCandidates: readonly string[];
    loading: boolean;
} => {
    const { data, loading } = useQuery<
        GetLensDiscoverabilityTagCandidatesQuery,
        GetLensDiscoverabilityTagCandidatesQueryVariables
    >(getLensDiscoverabilityTagCandidates, {
        variables: {
            lensId: lensOrSubmissionId,
        },
    });

    return useMemo(
        () => ({
            lensDiscoverabilityVisualTagCandidates:
                data?.getLensDiscoverabilityVisualTagCandidates.visualTagsList ?? [],
            lensDiscoverabilityLocationTagCandidates:
                data?.getLensDiscoverabilityLocationTagCandidates.locationTagsList ?? [],
            lensDiscoverabilityTimeTagCandidates: data?.getLensDiscoverabilityTimeTagCandidates.timeTagsList ?? [],
            loading: loading,
        }),
        [data, loading],
    );
};
